<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <search-bar v-model="formData" @search="handleSearch"></search-bar>
      </el-header>
      <el-main ref="main">
        <el-table
          border
          stripe
          :data="tableData"
          :height="tableHeight"
          v-if="tableHeight"
          v-loading="loading"
        >
          <el-table-column label="图片" prop="" show-overflow-tooltip align="center" width="100px">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="showDialog(scope.row, 0)" v-if="scope.row.imgUrlList.length">查看</el-link>
              <el-link :underline="false" disabled v-else>查看</el-link>
            </template>
          </el-table-column>
          <el-table-column label="产品编码" prop="productCode" show-overflow-tooltip width="180px"></el-table-column>
          <el-table-column label="产品名称" prop="productName" show-overflow-tooltip></el-table-column>
          <el-table-column label="品类" prop="variety" show-overflow-tooltip width="180px"></el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 10px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
    <!-- 图片&视频 -->
    <pic-video :data="rowData" :detailType="viewType" ref="picVideo"></pic-video>
  </div>
</template>

<script>
  import mixin from '@/views/preSalePlan/utils/mixin.js'
  import searchBar from './search'

  import picVideoMixin from './pic&video.mixin'
  export default {
    mixins: [mixin, picVideoMixin],
    components: {
      searchBar
    },
    data() {
      return {
        tableHeight: 0,
        loading: false,
        formData: {},
        tableData: [],
        paginationOpt: {
          pageSizes: [30, 60, 90],
          pageSize: 30,
          pageNum: 1,
          total: 0
        }
      }
    },
    mounted() {
      this.tableHeight = this.$refs['wrapper'].offsetHeight - 105;
      this.init();
    },
    methods: {
      handleSearch(data) {
        this.paginationOpt.pageNum = 1;
        this.formData = data;
        this.init();
      },
      init() {
        this.formData['dateTime'] = this.planTime;
        
        this.loading = true;
        let formData = {
          pageSize: this.paginationOpt.pageSize,
          pageNum: this.paginationOpt.pageNum,
          filterData: {
            ...this.formData
          }
        };
        this.$q.preSalePlan.getWhiteListByDate({data: formData})
        .then(res=>{
          this.tableData = res.data.records;
          this.paginationOpt['total'] = res.data.total;
        })
        .finally(_=>{
          this.loading = false;
        })
      },
      // 分页器 pagesize
      handleSizeChange(val) {
        this.paginationOpt.pageSize = val;
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      // 分页器 pageNum
      handleCurrentChange(val) {
        this.paginationOpt.pageNum = val;
        this.init();
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .container
    width auto 
    height calc(100% - 110px)
    box-sizing border-box
    border-radius 5px
  >>> .el-header
    background #ffffff
    padding 0 8px
    position relative
    border-radius 5px
  >>> .el-main
    padding 5px 8px
    background #ffffff
    border-radius 5px
</style>